import request from '@/utils/request'

// 查询码上办-链接管理列表
export function listLinkOld(query) {
  return request({
    url: '/web/msb/linkOld/list',
    method: 'get',
    params: query
  })
}